import { defineComponent, ref } from "vue";
import elzh from "element-plus/lib/locale/lang/zh-cn";
import elen from "element-plus/lib/locale/lang/en";
import urlAPI from "@/services/api";
import utils from "@/services/utils";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { key } from "./store";
export default defineComponent({
  data() {
    return {
      mainhandleSelect: key => {
        const strkeys = key.split("/");

        if (strkeys.length > 1) {
          this.$router.push({
            path: key
          });
          this.displayMenu();
        } else {
          ElMessage("[message]" + key);
        }
      },
      logoW: "",
      isRouterAlive: true
    };
  },

  components: {},
  mixins: [utils, urlAPI],

  setup() {
    const store = useStore(key);
    const elloczh = ref(elzh);
    const ellocen = ref(elen);
    return {
      elloczh,
      ellocen,
      store
    };
  },

  mounted() {
    if (this.$route.params.loc == undefined || this.$route.params.loc == "undefined" || this.$route.params.loc == null) {
      const loc = sessionStorage.getItem("lang");

      if (loc != null) {
        this.setloc(loc);
      }
    } else {
      this.setloc(this.$route.params.loc);
    }

    const isd = sessionStorage.getItem("isDark");

    if (isd == "1") {
      this.$store.state.isDark = true;
    }

    this.setDark(this.$store.state.isDark);
  },

  methods: {
    settinghandleSelect(key) {
      if (key == "logout") {
        this.logout().then(resp => {
          if (resp.code == 10000) {
            this.$router.push({
              name: "login"
            });
          }
        });
      } else if (key == "login") {
        this.loginFrom.name = "";
        this.loginFrom.pw = "";
        this.loginDialogVisible = true;
      } else {
        this.$i18n.locale = key;
        sessionStorage.setItem("lang", key);

        if (this.$route.name == "f") {
          this.isRouterAlive = false;
          this.$router.push({
            name: "f",
            params: {
              loc: key
            }
          }).then(() => {
            this.isRouterAlive = true;
            this.$router.go(0);
          });
        } // window.location.reload();

      }
    },

    // show() {
    //   // console.log(JSON.stringify(this.$store.state.progressList));
    // },
    // loginSub() {
    //   let form = this.$refs.ruleFormRef as HTMLFormElement;
    //
    //   form.validate((valid: boolean, fields: any) => {
    //     if (valid) {
    //       console.log("submit!", JSON.stringify(this.loginFrom));
    //     } else {
    //       console.log("error submit!", JSON.stringify(fields));
    //     }
    //   });
    // },
    goQuery() {
      sessionStorage.removeItem("exToken");
      sessionStorage.removeItem("user");
      this.$router.push({
        name: "goto"
      });
    },

    beforeChange() {
      // this.$store.state.isDark = !this.$store.state.isDark;
      const isD = !this.$store.state.isDark;

      if (isD) {
        sessionStorage.setItem("isDark", "1");
      } else {
        sessionStorage.setItem("isDark", "0");
      }

      this.setDark(isD);
      return new Promise(function (_resolve) {
        _resolve(true);
      });
    }

  }
});